<template>
  <div class="">
    <div class="flex p-3 justify-between">
      <div class="flex flex-row">
        <div>
          <h3 class="text-sm font-semibold text-gray-800">
            {{ data.directory }}
          </h3>
        </div>
      </div>
      <div
        class="bg-gray-300 text-gray-500 font-semibold text-xs px-1 py-2 rounded-md"
      >
        {{ data.category }}
      </div>
    </div>
    <div class="relative">
      <div class="square relative">
        <img
          :src="data.image_logo"
          alt=""
          class="advertisements__item__media"
        />
        <div class="absolute bottom-0 mb-2 flex flex-row gap-2">
          <div
            v-if="data.discount.length"
            class="discount flex items-center justify-items-center py-2 px-2 h-8 bg-pink-600 rounded-lg overflow-hidden"
          >
            <p
              class="text-xs text-white font-semibold whitespace-no-wrap truncate"
            >
              {{ data.discount }}
            </p>
          </div>
          <div
            v-if="data.apply_discount.length"
            @click="copyToClipboard(data.apply_discount)"
            class="cursor-pointer flex items-center justify-center justify-items-center py-2 px-2 w-24 h-8 bg-indigo-400 duration-300 rounded-lg overflow-hidden"
            :class="{
              'bg-indigo-600': !copied
            }"
          >
            <p
              class="text-xs text-white font-semibold whitespace-no-wrap truncate text-center"
            >
              {{ !copied ? data.apply_discount : "Copied" }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-center p-3 mb-3">
      <div class="w-56 text-sm">
        <p class="leading-5">{{ data.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
export default {
  props: {
    data: Object
  },
  setup() {
    const store = useStore();
    const primaryTextClamp = ref(true);
    const copied = ref(false);
    const user = computed(() => store.state.user);
    const role = computed(() => store.state.role);
    const togglePrimaryTextClamp = () => {
      primaryTextClamp.value = !primaryTextClamp.value;
    };
    const copyToClipboard = value => {
      navigator.clipboard.writeText(value);
      copied.value = true;
      setTimeout(() => {
        copied.value = false;
      }, 3000);
    };
    const openOurPlansModal = () => {
      store.commit("SET_OURPLANS_ACTIVE", true);
    };
    const toggleFavoriteState = async ad => {
      if (["free"].includes(role.value)) {
        openOurPlansModal();
        return true;
      }

      if (ad.isFavorite) {
        await store.dispatch("REMOVE_FAVORITE_ADD", {
          user_id: user.value.id,
          advertisement_id: ad.id
        });
      } else {
        await store.dispatch("ADD_FAVORITE_AD", {
          user_id: user.value.id,
          advertisement: ad
        });
      }
    };

    return {
      primaryTextClamp,
      togglePrimaryTextClamp,
      toggleFavoriteState,
      copyToClipboard,
      copied
    };
  }
};
</script>

<style scoped>
/* .post {
  filter: blur(8px);
} */
.text-606770 {
  color: #606770;
}
.square {
  width: 100%;
  display: flex;
  justify-content: center;
}
.clamp {
  max-height: calc(1rem * 7);
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.discount{
  max-width: 10rem;
}
.action {
  max-width: 100px;
  letter-spacing: normal;
  color: rgb(68, 73, 80);
  font-size: 12px;
  font-weight: bold;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
  line-height: 26px;
  text-align: center;
  height: 30px;
  background-position: 0 0;
  border: 1px solid #667eea;
  border-radius: 10px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  padding: 0 11px;
  position: relative;
  text-shadow: none;
  transition: all 300ms cubic-bezier(0.1, 0.7, 0.1, 1), border-width 1ms;
  transition-property: background, border-color, border-width, color;
  vertical-align: middle;
}
</style>
